










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'TimeSheetHours',
  components: {},
})
export default class TimeSheetHours extends Vue {
  @Prop() count;
  @Prop() text;
}
